import { Injectable } from '@angular/core';
import { DialogsService } from '../../services/dialog.service';
import { EventsNames } from '../enums/events-names.enum';
import { DialogState } from '../../models/dialog-state';
import {
  ParticipantOffersInvolvingProcessDialogContentAdapter
} from '../adapters/participant-offers-involving-process-dialog-content.adapter';

@Injectable({
  providedIn: 'root'
})
export class EventHandlersDialogService {
  constructor(private _dialogService: DialogsService) {}

  public showDialog(htmlContent: string, eventName: EventsNames) {
    let adaptedHtml = htmlContent;
    if (eventName === EventsNames.InvolvingProcess) {
      adaptedHtml = ParticipantOffersInvolvingProcessDialogContentAdapter.adapt(htmlContent);
    }

    this._dialogService.showErrorWithHtmlContent({
      headerText: 'Уведомление',
      content: adaptedHtml,
      closeButtonLabel: 'Прочитано',
      closable: true,
      styleClass: 'event-handlers-dialog',
    } as DialogState);
  }
}
